// import i18next from 'i18next';
import React from 'react';
// import en from './container/i18n/en';
// import ptBr from './container/i18n/pt-br';

// i18next.addResourceBundle('pt-br', 'fornecedor/container', ptBr);
// i18next.addResourceBundle('en', '/fornecedor/container', en);

const OrdemServicoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/vendas-servicos/ordem-servico',
      component: React.lazy(() => import('./OrdemServico')),
    },
  ],
};

export default OrdemServicoConfig;
